import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import isEmpty from 'lodash-es/isEmpty'
import { FtueOptions } from '../../functions/puzzlesApi'

interface IProps {
    disableNextButton: boolean
    isPlayerInteractedWithBoard: boolean
    ftueOptions?: FtueOptions
    onAnalysis: () => void
    onNext: () => void
}

const PuzzleButtons: React.FC<IProps> = (props) => {
    const { disableNextButton, isPlayerInteractedWithBoard, onAnalysis, onNext, ftueOptions } = props

    return (
        <Box display="flex" justifyContent="center" width="100%" gap="0.5rem">
            <Button onClick={onAnalysis} disabled={!isPlayerInteractedWithBoard || !isEmpty(ftueOptions)}>
                Analysis
            </Button>
            <Button onClick={onNext} disabled={disableNextButton || !isPlayerInteractedWithBoard}>
                Next
            </Button>
        </Box>
    )
}

PuzzleButtons.displayName = 'PuzzleButtons'

export default PuzzleButtons
